import { useEffect, useState } from "react";

// Same look as the loading screen in public/index.html, so the switch from
// the static page to React is seamless. After a few seconds it explains the
// wait (the server may be starting up) instead of leaving a blank screen.
export default function BootScreen({ message = "Carregando o Lumine…", compact = false }) {
  const [slow, setSlow] = useState(false);
  const [verySlow, setVerySlow] = useState(false);

  useEffect(() => {
    const a = setTimeout(() => setSlow(true), 5000);
    const b = setTimeout(() => setVerySlow(true), 15000);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, []);

  let text = message;
  if (verySlow) text = "O servidor está iniciando. Isso pode levar até 1 minuto — não feche a página.";
  else if (slow) text = "Quase lá… preparando seu painel.";

  return (
    <div className="lumine-boot" style={compact ? { minHeight: "50vh" } : undefined} role="status" aria-live="polite" data-testid="boot-screen">
      <img src="/lumine-symbol.svg" alt="" />
      <div className="lumine-boot-bar" />
      <p className="lumine-boot-text">{text}</p>
    </div>
  );
}
